import { Modal } from '@mui/material';
import React, { useState, useEffect, useRef } from 'react';
import Swal from 'sweetalert2';
import request from '../../../Helpers/API';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import DeleteIcon from '@mui/icons-material/Delete';
import { LoaderScreen } from '../../components/LoaderScreen';

export const CarruselImagenesModal = ({ open, handleClose, datos, idmodeloselect }) => {
    const [imagenesExistentes, setImagenesExistentes] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [imagenesBD, setImagenesBD] = useState([]);

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    useEffect(() => {
        setLoader({ ...loader, mostrar: true });
    
        request
            .get(`ListadoModelos/ObtenerCarrusel?idmodelo=${idmodeloselect}`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
    
                const imagenesLimpias = result.map((item) => {
                    try {
                        const parsed = JSON.parse(item.imagen);
                        return {
                            id_imagen: item.id_imagen || null,
                            documento: parsed.documento,
                            extension: "jpeg" // o infiere del base64 si quieres
                        };
                    } catch (error) {
                        return null;
                    }
                }).filter(Boolean); // filtra los null
    
                setImagenesBD(imagenesLimpias);
                console.log(imagenesLimpias);
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
            });
    }, [open]);
    

    
    useEffect(() => {
        if (open) {
            const imagenesProcesadas = imagenesBD.map(img => ({
                id_imagen: img.id_imagen,
                documento: img.documento.startsWith("data:image") ? img.documento : `data:image/${img.extension};base64,${img.documento}`,
                extension: img.extension || "jpg"
            }));

            setImagenesExistentes(imagenesProcesadas.slice(0, 4));
        }
    }, [imagenesBD]);

    useEffect(() => {
        if (!open) {
            setImagenesExistentes([]);
            setImagenesBD([]);
            setCurrentIndex(0);
        }
    }, [open]);

    const handleNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % (imagenesExistentes.length));
    };

    const handlePrev = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + imagenesExistentes.length) % (imagenesExistentes.length));
    };


    return (
        
        <Modal open={open}
            onClose={handleClose} // Esto cierra el modal cuando se hace clic fuera del contenido
        >
            
            <div className="modelos-imagen-carrusel-modal">


                <div className="slider-box" onClick={() => handleClose()}>
                    <div className="slider-navigation">
                        <img
                            src={imagenesExistentes[(currentIndex - 1 + imagenesExistentes.length) % imagenesExistentes.length]?.documento}
                            alt={`Imagen anterior`}
                            className="anterior-foto"
                            onClick={(e) => { e.stopPropagation(); handlePrev(); }}  // Evita que el clic cierre el modal
                        />

                        <ul>
                            <li>
                                <div className='img-container'>
                                    <img
                                        src={imagenesExistentes[currentIndex]?.documento}
                                        alt={`Imagen ${currentIndex + 1}`}
                                        className="snapper"
                                        onClick={(e) => e.stopPropagation()}  // Evita que el clic cierre el modal
                                    />
                                </div>
                            </li>
                        </ul>
                        <img
                            src={imagenesExistentes[(currentIndex + 1) % imagenesExistentes.length]?.documento}
                            alt={`Imagen siguiente`}
                            className={`siguiente-foto`} // Animación activada
                            onClick={(e) => { e.stopPropagation(); handleNext(); }}  // Evita que el clic cierre el modal
                        />
                    </div>
                </div>
            </div>
        </Modal>
    );
};
